import { useCallback, useEffect, useState } from "react";

export type PromiseCall<Response> = (...args: any[]) => Promise<Response>;

const useAsync = <T, E = string>(
  asyncFunction: PromiseCall<T>,
  immediate = true
) => {
  const [status, setStatus] = useState<
    "idle" | "pending" | "success" | "error"
  >("idle");
  const [value, setValue] = useState<T | null>(null);
  const [error, setError] = useState<E | null>(null);

  const execute = useCallback(
    async (...args: any[]) => {
      setStatus("pending");
      setValue(null);
      setError(null);
      try {
        const response = await asyncFunction(...args);
        setValue(response);
        setStatus("success");
      } catch (err: any) {
        setError(err.message);
        setStatus("error");
      }
    },
    [asyncFunction]
  );

  useEffect(() => {
    if (immediate) {
      execute();
    }
  }, [execute, immediate]);

  return { execute, status, value, error };
};

export default useAsync;
